import { Heading as Heading_ } from "@chakra-ui/react";
import { forwardRef } from "react";
export const Heading = forwardRef(({ ...props }, ref) => {
    return <Heading_ ref={ref} {...props}>{props?.children}</Heading_>
});